import {doAuthenticatedQuery} from "./doQuery";
import {gql} from "graphql-request";
import {saasFragment} from "./Fragments";
import {transformConnectedSaasFlat} from "./sharedTransforms";
import {ICompanyAccess} from "../../types/Company";

export const getClientInfoQuery = async (accessToken?: any): Promise<ICompanyAccess> => {
    const theQuery = async (client: any) => {
        const result = client.request(
            clientInfoQuery,
            {}
        );
        return result;
    }

    let response;
    try {
        response = await doAuthenticatedQuery(
            theQuery, accessToken
        );
    }
    catch (error) {
        console.error('getClientInfo failed')
        throw (error)
    }

    const result = getClientInfoFromQueryResponse(response);
    return result;
};

const getClientInfoFromQueryResponse = (
    response:
        {
            client: {
                pub_id: string;
                name: string;
                source_of_truth_saas: any;
                slug: string;
                is_disabled: boolean;
            }[];},
): ICompanyAccess => {
    // The graphQL returns an array but there must only ever be one client
    if (!response || !response.client || response.client.length === 0){
        throw new Error('Could not load client');
    }
    const singleClient = response?.client[0];

    return transformCompanyAccess(singleClient);

};

export const transformCompanyAccess = (client: any) : ICompanyAccess => {
    const sotSaasInfo = transformConnectedSaasFlat(
      client?.source_of_truth_saas,
    );

    return {
        id: client?.pub_id,
        name: client?.name,
        sourceOfTruth: sotSaasInfo,
        slug: client?.slug,
        disabled: client?.is_disabled,
    }
}

const clientInfoQuery = gql`
  query ClientInfo {
    client{
      pub_id
      name
      slug
      is_disabled
      source_of_truth_saas{
        ...Saas
      }
    }
  } ${saasFragment}
`;